import { useFormState } from 'informed';
import { traverseNestedObjectAndGrabValue } from 'shared-helpers/common';
import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { Popover } from 'components/common/popover';
import { UserAttributesConditionsManager } from '.';

import type { UserAttributesConditionsProps } from './UserAttributesConditionsManager';

type Props = UserAttributesConditionsProps;

const UserAttributesConditionsButton = ({
  availableAttributes,
  fieldPrefix,
  includeAuthenticationTypeCondition,
  includeEmailCondition,
  includeEmailDomainCondition,
  includeIsSelfRegisteredCondition
}: Props) => {
  const { messages, theme } = useReduxState();

  const formState = useFormState();

  const numberOfConditions =
    traverseNestedObjectAndGrabValue(
      formState.values,
      `${fieldPrefix ? fieldPrefix + '.' : ''}conditions`
    )?.length || 0;

  return (
    <>
      <Popover
        content={
          <div style={{ minWidth: 540 }}>
            <UserAttributesConditionsManager
              availableAttributes={availableAttributes}
              fieldPrefix={fieldPrefix}
              includeAuthenticationTypeCondition={
                includeAuthenticationTypeCondition
              }
              includeEmailCondition={includeEmailCondition}
              includeEmailDomainCondition={includeEmailDomainCondition}
              includeIsSelfRegisteredCondition={
                includeIsSelfRegisteredCondition
              }
            />
          </div>
        }
        forceMount={true}
      >
        {(setIsOpen) => (
          <>
            <Button
              category="lighter"
              isRounded={true}
              text={
                <span className="button-content">
                  {messages.userAttributesConditions}
                  {numberOfConditions ? (
                    <span className="button-conditions">
                      {numberOfConditions}
                    </span>
                  ) : null}
                  {/* {JSON.stringify(formState.values[fieldPrefix])} */}
                </span>
              }
              onClick={() => setIsOpen(true)}
              size="small"
              style={{ padding: '4px 9px' }}
            />
          </>
        )}
      </Popover>

      <style jsx>{`
        .button-content {
          align-items: center;
          display: flex;
          gap: 8px;
        }
        .button-conditions {
          align-items: center;
          background-color: white;
          border-radius: 50px;
          font-size: 1.2rem;
          font-weight: 700;
          display: inline-flex;
          justify-content: center;
          margin: -1px -5px -1px 0;
          padding: 1px 6px;
        }
      `}</style>
    </>
  );
};

export default UserAttributesConditionsButton;
